import { render } from "./ClientApprovalAccordion.vue?vue&type=template&id=d302984a&scoped=true"
import script from "./ClientApprovalAccordion.vue?vue&type=script&lang=js"
export * from "./ClientApprovalAccordion.vue?vue&type=script&lang=js"

import "./ClientApprovalAccordion.vue?vue&type=style&index=0&id=d302984a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d302984a"]])

export default __exports__